<template>
  <section class="step-block">
    <div class="container">
      <TitleWithLines
        v-if="data.title"
        class="step-block__title"
        :title="data.title"
      />

      <div class="step-block__body">
        <div
          v-for="(step, index) in data.items"
          :key="index"
          class="step-block__item"
          :class="{ 'step-block__item_left': index % 2 == 0 }"
        >
          <StepItem
            :imageSvg="step.imageSvg"
            :title="step.title"
            :description="step.description"
            :dateEnd="step.dateEnd"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import TitleWithLines from '@/components/shared/TitleWithLines'
  import StepItem from '@/components/shared/StepItem'
  export default {
    name: 'StepBlock',

    components: { TitleWithLines, StepItem },

    props: {
      data: {
        type: Object,
        default: () => ({})
      }
    }
  }
</script>

<style lang="scss">
.step-block {
  padding-top: 192px;
  overflow: hidden;

  @include tablet {
    padding-top: 100px;
  }

  &__title {
    width: 100%;
    max-width: 1015px;
    margin-bottom: 96px;

    @include mobile {
      padding-left: 16px;
      padding-right: 100px;
      margin-bottom: 47px;
    }
  }

  &__body {
    width: 100%;
    max-width: 864px;
    margin: 0 auto;
  }

  &__item {
    display: flex;
    justify-content: flex-start;

    &:not(:last-child) {
      height: 327px;
    }

    @include mobile {
      height: auto;

      &:not(:last-child) {
        margin-bottom: 48px;
      }
    }

    &_left {
      justify-content: flex-end;
    }
  }
}
</style>
